import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 60 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 18\" id=\"icon-more\">\r\n  <text id=\"icon-more_MORE_\" data-name=\"MORE&gt;\" transform=\"translate(0 16)\" fill=\"#de3a00\" font-size=\"18\" font-family=\"SourceHanSansCN-Normal, Source Han Sans CN\"><tspan x=\"0\" y=\"0\">MORE&gt;</tspan></text>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol